/*
 * Where time lives.
 *
 *   /time                                  your timesheet (Board, today)
 *   /time?view=day&date=YYYY-MM-DD         a day
 *   /time?date=YYYY-MM-DD&entry=<id>       a day with one entry open
 *   /time/review                           Billing review (firm admins)
 */
import { matchPath } from "react-router-dom";

export const TIME_PATH = "/time";
export const TIME_REVIEW_PATH = "/time/review";

export type TimesheetView = "board" | "day" | "week";

export const TIMESHEET_VIEWS: readonly TimesheetView[] = [
  "board",
  "day",
  "week"
];

export const isTimesheetView = (v: unknown): v is TimesheetView =>
  typeof v === "string" && (TIMESHEET_VIEWS as readonly string[]).includes(v);

export const isTimePath = (pathname: string): boolean =>
  matchPath({ path: TIME_PATH, end: true }, pathname) !== null;

export const timePathFor = (
  opts: {
    date?: string | null;
    view?: TimesheetView;
    entry?: string | null;
  } = {}
): string => {
  const params = new URLSearchParams();
  if (opts.view && opts.view !== "board") params.set("view", opts.view);
  if (opts.date) params.set("date", opts.date);
  if (opts.entry) params.set("entry", opts.entry);
  const qs = params.toString();
  return qs ? `${TIME_PATH}?${qs}` : TIME_PATH;
};
